"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlobalVirtualCategoryBySlug = void 0;
const routes_1 = require("../../routes");
const getGlobalVirtualCategoryBySlug = (client) => async (params) => {
    const url = routes_1.ENDPOINTS.GET_GLOBAL_VIRTUAL_CATEGORY_BY_SLUG.applyParams(params);
    const response = await client.get(url);
    return response.data;
};
exports.getGlobalVirtualCategoryBySlug = getGlobalVirtualCategoryBySlug;
